import React, { Fragment, useState } from 'react';
import { BackendDevelopment, Design, Development, FrontendDevelopment, InterfaceDesign, UIDesign, UserExperience, UXDesign } from '../../../Constant';
import { Btn, H5, LI, UL } from '../../../AbstractElements';
import { Card, CardHeader, Col, Collapse } from 'reactstrap';
import { ChevronDown, ChevronUp } from 'react-feather';

const CategoriesClass = () => {
  const [isDesign, setIsDesign] = useState(true);
  return (
    <Fragment>
      <Col xl='12'>
        <Card>
          <CardHeader>
            <H5 className='mb-0 p-0'>
              <Btn className='btn btn-link accordion-icon' onClick={() => setIsDesign(!isDesign)} color='transperant'>
                Categories
                {isDesign ? <ChevronUp /> : <ChevronDown />}
              </Btn>
            </H5>
          </CardHeader>
          <Collapse isOpen={isDesign} id='collapseicon1' aria-labelledby='collapseicon1' data-parent='#accordion'>
            <div className='categories'>
              <div className='learning-header'>
                <span className='f-w-600'>{Design}</span>
              </div>
              <UL className='simple-list'>
                <LI>
                  <a href='#javascript'>{UIDesign} </a>
                  <span className='badge badge-primary pull-right'>{'28'}</span>
                </LI>
                <LI>
                  <a href='#javascript'>{UXDesign} </a>
                  <span className='badge badge-primary pull-right'>{'35'}</span>
                </LI>
                <LI>
                  <a href='#javascript'>{InterfaceDesign} </a>
                  <span className='badge badge-primary pull-right'>{'17'}</span>
                </LI>
                <LI>
                  <a href='#javascript'>{UserExperience} </a>
                  <span className='badge badge-primary pull-right'>{'26'}</span>
                </LI>
              </UL>
            </div>
            <div className='categories pt-0'>
              <div className='learning-header'>
                <span className='f-w-600'>{Development}</span>
              </div>
              <UL className='simple-list'>
                <LI>
                  <a href='#javascript'>{FrontendDevelopment}</a>
                  <span className='badge badge-primary pull-right'>{'48'}</span>
                </LI>
                <LI>
                  <a href='#javascript'>{BackendDevelopment}</a>
                  <span className='badge badge-primary pull-right'>{'19'}</span>
                </LI>
              </UL>
            </div>
          </Collapse>
        </Card>
      </Col>
    </Fragment>
  );
};

export default CategoriesClass;
